import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { BatchService } from '../../services/batch.services';
import { MessageService } from '../../services/message.service';
@Component({
  selector: 'rm-delete-package',
  templateUrl: './delete-batch.component.html',
  styleUrls: ['./delete-batch.component.css']
})
export class DeleteBatchComponent implements OnInit {

  deleteBatchForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private batchService: BatchService,
    private msgService: MessageService
  ) { }

  ngOnInit() {
    this.deleteBatchForm = this.fb.group({
      batchNo: ['', [Validators.required]],
    });
  }

  deleteBatchSubmit(val) {
    this.batchService.deletePackageByBatchNo({batchNo: val.batchNo}).subscribe(
      (response: string) => {
        this.deleteBatchForm.reset();
        this.msgService.showSuccess(response);
      }, err => {
        this.msgService.showError(this.msgService.packageDeleteFail);
      }
    );
  }
}
